import React, { useState } from 'react';
import { Logo } from '../../../Components/Logo/Logo';
import { GameGraphics } from '../../../Components/GameGraphics/GameGraphics';
import type { TileProps } from '../tiles';

export const AssetTile = ({
  type,
  gameGraphics,
  isLoading = false,
  isTableClosed,
  isUnavailable,
  className
}: TileProps) => {
  const [graphicsLoading, setGraphicsLoading] = useState(true);
  const [graphicsError, setGraphicsError] = useState(false);

  const isContentLoading = !graphicsError && (isLoading || graphicsLoading);
  const graphicsDisabled = isUnavailable || (type !== 'Casino' && isTableClosed);
  const shouldRenderLogo = isContentLoading || (graphicsError && !graphicsDisabled);

  return (
    <article className={`group relative flex flex-col rounded-32 h-160 md:h-208 ${className}`}>

      <GameGraphics
        {...gameGraphics}
        backgroundUrl={gameGraphics?.backgroundUrl}
        isLoading={isContentLoading}
        onLoaded={() => setGraphicsLoading(false)}
        onError={() => setGraphicsError(true)}
        error={graphicsError}
        imageWidth={400}
        disabled={graphicsDisabled}
        disableCache={type === 'Live'}
        useDarkGradient={type === 'Live' && !isUnavailable}
        rounded='rounded-32'
        backgroundStyle='object-fill'
      />

      <div className='flex h-full flex-grow flex-col p-16 pb-32 text-neutrals-white fill-neutrals-white stroke-neutrals-white'>
        <div className='z-10 m-auto h-full'>
          {shouldRenderLogo && (
            <Logo
              text={isContentLoading ? 'Loading...' : ''}
              className={`m-auto items-center w-56 ${isContentLoading && 'pt-28'}`} />
          )}
        </div>
      </div>
    </article>
  );
};
